import { render } from "./addSliderHeroPaper.vue?vue&type=template&id=fe6aef58&scoped=true"
import script from "./addSliderHeroPaper.vue?vue&type=script&lang=js"
export * from "./addSliderHeroPaper.vue?vue&type=script&lang=js"

import "./addSliderHeroPaper.vue?vue&type=style&index=0&id=fe6aef58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe6aef58"]])

export default __exports__